import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type {
	StarterDashboardV2PersonalizedTasksPollQuery,
	StarterDashboardV2PersonalizedTasksPollQueryVariables,
} from './getPersonalizedTasks.graphql';
import { StarterDashboardV2PersonalizedTasksPoll } from './getPersonalizedTasks.graphql';

export type { StarterDashboardV2PersonalizedTasksPollQuery };

export async function getPersonalizedTasks(
	slug: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<StarterDashboardV2PersonalizedTasksPollQuery | null> {
	const { data } = await fetch<
		StarterDashboardV2PersonalizedTasksPollQuery,
		StarterDashboardV2PersonalizedTasksPollQueryVariables
	>({
		query: StarterDashboardV2PersonalizedTasksPoll,
		variables: { slug },
		rejectOnError: false,
	});

	return data ?? null;
}
